type LogLevel = 'debug' | 'info' | 'warn' | 'error' | 'silent';

const LEVEL_PRIORITY: Record<LogLevel, number> = {
  debug: 10,
  info: 20,
  warn: 30,
  error: 40,
  silent: 50
};

function resolveLogLevel(): LogLevel {
  const env = (globalThis as any).process?.env?.LOG_LEVEL;
  const rawLevel = typeof env === 'string' ? env.toLowerCase() : 'warn';
  return rawLevel in LEVEL_PRIORITY ? rawLevel as LogLevel : 'info';
}

export class Logger {
  private readonly name: string;

  constructor(name: string) {
    this.name = name;
  }

  public debug(message: string, data?: unknown): void {
    this.write('debug', message, data);
  }

  public info(message: string, data?: unknown): void {
    this.write('info', message, data);
  }

  public warn(message: string, data?: unknown): void {
    this.write('warn', message, data);
  }

  public error(message: string, data?: unknown): void {
    this.write('error', message, data);
  }

  private write(level: Exclude<LogLevel, 'silent'>, message: string, data?: unknown): void {
    if (LEVEL_PRIORITY[level] < LEVEL_PRIORITY[resolveLogLevel()]) return;

    const payload = data === undefined ? '' : data;
    const prefix = `[${this.name}] ${level.toUpperCase()} ${message}`;

    if (level === 'error') {
      console.error(prefix, payload);
    } else if (level === 'warn') {
      console.warn(prefix, payload);
    } else {
      console.log(prefix, payload);
    }
  }
}

export function createLogger(name: string): Logger {
  return new Logger(name);
}
